module.exports = __webpack_public_path__ + "img/CLOCK.271d1e42.svg";